import {
	Netzwerk,
	Vermarktung,
	Handshake,
	Transaction,
	ValueUp,
} from "../components/Icons";

const Offer = (props: any) => {
	const smallerMarginTop = props.title === "Transaktionsbegleitung";
	return (
		<div className="col-span-1 flex flex-col">
			<div className="self-center">{props.icon}</div>

			<span
				className={
					(smallerMarginTop ? "mt-2" : "mt-4") +
					" text-center text-xl font-bold"
				}
			>
				{props.title}
			</span>
		</div>
	);
};

const AboutUs = () => {
	return (
		<div
			id="aboutus"
			className="flex min-h-screen flex-col bg-ds-gray-normal p-6 text-white sm:p-12 xl:px-28 2xl:px-44"
		>
			<h1 className="mt-12 mb-16 self-center break-words text-center text-4xl text-ds-yellow md:text-5xl">
				Deutsch-Schweizerische Immobiliengesellschaft
			</h1>
			<div className="grid-cols-1 gap-x-10 md:grid lg:grid-cols-5 2xl:grid-cols-10">
				<div className="col-span-1 lg:col-span-3 2xl:col-span-5">
					<h2 className="mt-8 mb-12 text-center text-4xl font-semibold md:text-4xl lg:mt-0 lg:text-left">
						Über <span className="text-ds-yellow">uns.</span>
					</h2>
					Wir als Deutsch-Schweizerische Immobiliengesellschaft sind
					ein Family Office mit Sitz in Luzern in der Schweiz und in
					Radebeul bei Dresden in Deutschland.
					<br />
					<br />
					Unser Tätigkeitsfeld erstreckt sich vom klassischen
					Immobilieninvestment bis hin Transaktionsbegleitung und
					Vermittlung für Eigentümer, Projektentwickler und
					eigenkapitalstarke, institutionelle Investorengruppen.
					<br />
					<br />
					Speziell haben wir dabei den Fokus auf Wohn- und
					Gewerbeliegenschaften in grösseren Städten sowie Gemeinden
					der gesamten deutschsprachigen Schweiz gelegt.
					<br />
					<br />
					In Deutschland liegt der Fokus auf grösseren Städten im
					gesamten Bundesgebiet.
					<br />
					<br />
					Dabei treten wir als Initiator auf und bringen je nach
					Bedarf Eigentümer, Pächter, Projektentwickler und Investoren
					schon in einer frühen Phase zusammen.
					<br />
					<br />
					Das Ziel ist es, einen effizienten Interessensausgleich zu
					erreichen, das Vorhaben aktiv zu begleiten und zum Erfolg zu
					führen.
					<br />
					<br />
					Unsere üblichen begleiteten Transaktionsvolumen bewegen sich
					in der Schweiz zwischen 5 bis 50 Mio. CHF, in Deutschland
					zwischen 10-100 Mio. €.
					<br />
					<br />
					Im Einzelfall begleiten wir auch gern grössere
					Transaktionen.
					<br />
					<br />
					Unser sorgfältig ausgesuchtes Team ist bekannt für
					Diskretion, Seriosität, Zuverlässigkeit und steht Ihnen gern
					für eine professionelle Beratung zur Verfügung.
					<br />
					<br />
					Erwarten Sie mehr von uns, als Sie bisher vom
					Immobilienmarkt kennen und stellen Sie uns und unsere
					Qualität auf die Probe.
				</div>
				<div className="col-span-1 mb-6 flex flex-col items-center lg:col-span-2 2xl:col-span-2">
					<h2 className="mt-8 text-center text-4xl font-semibold md:text-4xl lg:mt-0">
						Was wir <span className="text-ds-yellow">bieten.</span>
					</h2>

					<div className="grid-col-1 mt-12 grid grid-flow-row gap-y-6 sm:grid-cols-2 lg:grid-cols-1">
						<Offer
							icon={
								<ValueUp className="h-16 w-16 fill-ds-yellow" />
							}
							title="Investment/An- & Verkauf"
						/>
						<Offer
							icon={
								<Transaction className="h-16 w-16 fill-ds-yellow" />
							}
							title="Transaktionsbegleitung"
						/>
						<Offer
							icon={
								<Vermarktung className="h-12 w-12 fill-ds-yellow" />
							}
							title="Global- & Einzelvertrieb"
						/>
						<Offer
							icon={
								<Handshake className="h-12 w-12 fill-ds-yellow" />
							}
							title="Partnerschaften & Kooperationen"
						/>
						<Offer
							icon={
								<Netzwerk className="h-12 w-12 fill-ds-yellow" />
							}
							title="Netzwerk"
						/>
					</div>
				</div>
				<div className="hidden h-full lg:col-span-3 2xl:block">
					<img
						className="h-full w-full object-cover"
						src="/assets/aboutus_handshake.jpg"
						alt="hands"
					/>
				</div>
			</div>
		</div>
	);
};

export default AboutUs;
